import { Suspense } from "react";
import { useState } from "react";
import { ContactDetailsProps } from "../../../../types/components/contactDetails.types";
import { Member } from "../../../../types/components/member.types";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import { CustomInput } from "../../../shared/CustomInput";

import "./contactDetails.css";

const ContactDetails = ({ member }: Member): JSX.Element => {
	const {
		email,
		address_line_1,
		address_line_2,
		city,
		contact_label,
		phone_number,
		state,
		ZIP,
		country,
		phone_extension
	} = member;
	const [contactDetails] = useState({
		Email: email,
		"Contact Label": contact_label ? initCapitalize(contact_label) : "",
		"Phone Extension": phone_extension,
		"Phone Number": phone_number,
		"Address Line 1": address_line_1,
		"Address Line 2": address_line_2,
		City: city,
		State: state,
		"ZIP Code": String(ZIP).length > 5 ? ZIP.substring(0, 5) + "-" + ZIP.substring(5) : ZIP,
		Country: country
	});

	return (
		<div className="contact-details">
			<div className="details-form-container">
				{Object.entries(contactDetails).map(([label, value], index) => {
					return (
						<div className="details-form-row" key={index}>
							<div className="details-form-label">{label}</div>
							<Suspense fallback={<div />}>
								<CustomInput value={value} disabled={true} />
							</Suspense>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ContactDetails;
